export const environment = {
  production: false,
  apiUrl:
    'https://test-386a1d0e-051a-4d09-bdc8-9a6f73334444-app.psicogenius.it/api',
  googleAPIKey: 'AIzaSyAxy7M_MrXg0SUN35XOg8Ys48_QeR9QNGk',
  baseUrl:
    'https://test-386a1d0e-051a-4d09-bdc8-9a6f73334444-app.psicogenius.it/',
  clientId:
    '14581068180-a067io0h8q8d4qte18anfmm9js69telh.apps.googleusercontent.com',
};
